import React, { useEffect, useState } from 'react';
import SessionManager from '../../routes/SessionManager';
import CommonUtils from '../../util/CommonUtils';
import LocationCard from './LocationCard';
import $ from 'jquery';
import 'jquery-ui/ui/widgets/sortable';
import Toastr from 'toastr';

function DashboardLeadership() {
    let sessionManager = new SessionManager();
    let user = sessionManager.readCookie('user');

    const [customer, setCustomer] = useState(null);
    const [zoneOrderChanged, setZoneOrderChanged] = useState(false);

    useEffect(() => {
        fetchCustomer();

        let sortableContainer = $('.sortable');
        sortableContainer.sortable({
            placeholder: ".sortable-placeholder",
            forcePlaceholderSize: true,
            stop: (event, ui) => {
                setZoneOrderChanged(true);
            }
        });

    }, []);

    const fetchCustomer = async () => {
        let _c = await CommonUtils.getCustomer(user.customer_id || user.site_selected.customer_id, user);
        setCustomer(_c);
    }

    let site_loc_recs = [];
    if (customer && customer.leadership_sites) {
        for (let s of Object.keys(customer.leadership_sites))
            for (let l of customer.leadership_sites[s]) {
                site_loc_recs.push({ location_id: l, site_id: s });
            }
        if (site_loc_recs && customer.zone_prefs) {
            site_loc_recs.sort((x, y) => customer.zone_prefs.indexOf(x.location_id) - customer.zone_prefs.indexOf(y.location_id))
        }
    }

    const zoneCardClassName = 'location-card col-md-' + ((site_loc_recs.length > 0 && site_loc_recs.length < 4) ? (12 / site_loc_recs.length) : 4);
    const saveZoneOrderPreferences = async () => {
        let sortableContainer = $('.sortable');
        console.log('customer.leadership_sites', customer.leadership_sites)
        const zone_prefs = sortableContainer.sortable('toArray', { attribute: 'zone' });
        if (customer.customer_id && zone_prefs.length > 0) {
            let result = await CommonUtils.saveCustomer({ customer_id: customer.customer_id, zone_prefs: zone_prefs }, user);
            if (result) {
                Toastr.success('Preferences saved !');
                setZoneOrderChanged(false);
            }
        }
    }

    return (
        <div className="page-container">
            <div className="row">
                <div className="col-12">
                    {zoneOrderChanged && <button className="btn btn-sm btn-primary pull-right m-2" onClick={saveZoneOrderPreferences}>Save Preferences</button>}
                </div>
            </div>
            <div className="row sortable">
                {
                    customer ? (
                        site_loc_recs ? <>
                            {site_loc_recs.map(sl => <div key={sl.location_id} className={zoneCardClassName} zone={sl.location_id}><LocationCard site_id={sl.site_id} location_id={sl.location_id} /></div>)}
                        </>
                            :
                            <div>No sites configured for leadership to view.</div>
                    )
                        : <div>Loading...</div>}
            </div>
        </div>
    )
}

export default DashboardLeadership;